import {
  Fragment,
  MouseEvent,
  MouseEventHandler,
  ReactEventHandler,
  useEffect,
  useState,
} from "react";
import axios from "axios";
import PatientTabs from "./Tabs";
import {
  Paper,
  Avatar,
  Title,
  Flex,
  Button,
  Divider,
  Tabs,
  Menu,
  ScrollArea,
  LoadingOverlay,
  createStyles,
  Box,
  Loader,
  ActionIcon,
  Text,
  Badge,
} from "@mantine/core";
import { IconCaretDown, IconHeart } from "@tabler/icons-react";
import { useMedplum } from "@medplum/react";
import {
  useLocation,
  useNavigate,
  useNavigationType,
  useParams,
} from "react-router-dom";
import { Measurement } from "../../Vitals/Measurements";
import { MedicalHistory } from "./MedicalHistory";
import { Observation } from "./Observation";
import { Immunization } from "./Immunization";
import { Reports } from "./Reports";
import { CareTeam } from "./CareTeams";
import {
  circularPlatformLogo,
  getClientTypes,
  getIntegrationTypes,
  getObjectByName,
  platformLogo,
} from "../../../utils";
import { RedirectingModal } from "../../../components/RedirectingModal";
import "./index.css";
import MedicalDocumentModal from "./UploadMedicalDocument";
import { DocReports } from "./DocReport";
import { ChatWindow } from "../../../components/ChatWindow";
import { Summary } from "../../AIRecipes/SummaryAi";
import doctorSvg from "../../../assets/img/patient.svg";
import {
  formatAiSummary,
  formatCardioSummary,
  formatLosPrediction,
  formatReadmissionPrediction,
  getCardioPrediction,
  getSummary,
} from "../../AIRecipes/aiService";
import { showNotification } from "@mantine/notifications";
import { AppointmentPage } from "../../Appointment/Appointment";
import { Appointment } from "./Appointments";
import { AIRecipesModal } from "./RecipeModal";
import { fetchCoverageResponseForPatient } from "./service";
import { CarePlan } from "./CarePlan";

const useStyles = createStyles((theme) => ({
  platformLogo: {
    marginRight: "10px",
    width: "25px",
    height: "25px",
  },
  medicalDocPaper: {
    marginTop: "20px",
    borderRadius: "8px",
    marginLeft: "0px",
    marginRight: "0px",
    padding: "20px",
    background: "'#FFF",
    boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
  },
}));

export function PatientDetail() {
  const medplum = useMedplum();
  const location = useLocation();
  const nt = useNavigationType();
  const { patientId }: any = useParams();
  const profile = medplum.getProfile();

  const initSummaryTags = {
    diseases: [] as string[],
    drugs: [] as string[],
    observations: [] as string[],
  };
  const [isEpic, setIsEpic] = useState<boolean>(false);
  const navigate = useNavigate();

  const [patientDetails, setPatientDetails] = useState<any>({});
  const [coverageEligibilityResponse, setCoverageEligibilityResponse] = useState<any>();


  const [measurementId, setMeasurmentId] = useState("");
  const [activeTab, setActiveTab] = useState("Medical History");
  const [clientsOptions, setClientsOptions] = useState<any>([]);
  const [selectedClient, setSelectedClient] = useState<any>({});
  const [visible, setVisible] = useState(false);
  const [vendor, setVendor] = useState<any>("");
  const [measurements, setMeasurments] = useState<Array<string>>([]);
  const [disconnecting, setDisconnecting] = useState(false);
  const [disabledVitals, setDisabledVitals] = useState<Array<string>>([]);
  const [showAiSummary, setShowAiSummary] = useState<boolean>(false);
  const [summaryTags, setSummaryTags] = useState(initSummaryTags);
  const [aiResponse, setAiResponse] = useState<string>("");
  const [pushToEpic,setPushToEpic]=useState<boolean>(false);
  const [cardioPrediction, setCardioPrediction] = useState<
    string | undefined
  >();
  const [cardioRed, setCardioRed] = useState<boolean | undefined>(false);

  const [aiModal, setAiModal] = useState(false);
  const [isMedicalDocumentModalOpen, setIsMedicalDocumentModalOpen] =
    useState(false);
  const [refreshFlag, setRefreshFlag] = useState<boolean>(false);
  const query = new URLSearchParams(location.search);
  const clientId = query.get("clientId") as string;
  const { classes } = useStyles();
  const tabs = [
    "Medical History",
    "Observations",
    "Immunization",
    "Diagnostic Reports",
    "Appointments",

    "Clinical Documents",
    "Care Plan"
  ];

  useEffect(() => {
    getPatientDetails();
    getDevices();
    fetchCoverageResponse()
  }, []);

  useEffect(() => {
    if (selectedClient.integrationType) {
      let integrationType = selectedClient.integrationType[0];
      if (integrationType === "Google Fit") {
        setMeasurments([
          "Blood Pressure",
          "Blood Glucose",
          "Heart Rate",
          "SPO2",
          "Height",
          "Weight",
          "Body Fat",
          "Body Temperature",
          "Steps",
        ]);
        setDisabledVitals([
          "BMR",
          "Move Minutes",
          "Hydration",
          "Nutrition",
          "Cervical Mucus",
          "Cervical Position",
          "Menstruation",
          "Ovulation",
          "Sleep",
          "Vaginal spotting",
        ]);
        setMeasurmentId("Blood Pressure");
      } else if (integrationType === "Apple") {
        setMeasurments([
          "Blood Pressure",
          "Blood Glucose",
          "Heart Rate",
          "SPO2",
          "Height",
          "Weight",
          "Body Fat",
          "Body Temperature",
          "Steps",
          "BMI",
          "ECG",
          "Calories burned",
          "Cycling",
          "Insulin Delivery",
        ]);
        setDisabledVitals([
          "Move Minutes",
          "Hydration",
          "Nutrition",
          "Cervical Mucus",
          "Cervical Position",
          "Menstruation",
          "Ovulation",
          "Sleep",
          "Vaginal spotting",
        ]);
        setMeasurmentId("Blood Pressure");
      } else if (integrationType === "Dexcom") {
        setMeasurments(["Blood Glucose"]);
        setMeasurmentId("Blood Glucose");
        setDisabledVitals([]);
      } else if (integrationType === "Fitbit") {
        setMeasurments(["Weight", "Body Fat", "BMI"]);
        setDisabledVitals([
          "Blood Pressure",
          "Blood Glucose",
          "Heart Rate",
          "SPO2",
          "Height",
          "Body Temperature",
          "Steps",
        ]);
        setMeasurmentId("Weight");
      } else if (integrationType === "Oura") {
        setMeasurments(["Heart Rate", "SPO2"]);
        setDisabledVitals([
          "Blood Pressure",
          "Blood Glucose",
          "Heart Rate",
          "Height",
          "Body Temperature",
          "Steps",
        ]);
        setMeasurmentId("Heart Rate");
      } else if (integrationType === "Polar") {
        setMeasurments(["SPO2", "Body Temperature"]);
        setDisabledVitals([
          "Blood Pressure",
          "Blood Glucose",
          "Heart Rate",
          "Height",
          "Body Temperature",
          "Steps",
        ]);
        setMeasurmentId("SPO2");
      } else if (integrationType === "Withings") {
        setMeasurments(["Steps", "Heart Rate"]);
        setDisabledVitals([
          "Blood Pressure",
          "Blood Glucose",
          "Height",
          "Body Temperature",
          "SPO2",
        ]);
        setMeasurmentId("Steps");
      } else if (integrationType === "Strava") {
        setMeasurments(["Body Temperature", "Heart Rate"]);
        setDisabledVitals([
          "Blood Pressure",
          "Blood Glucose",
          "Height",
          "Steps",
          "SPO2",
        ]);
        setMeasurmentId("Body Temperature");
      } else if (integrationType === "Garmin") {
        setMeasurments([
          "Blood Pressure",
          "Heart Rate",
          "SPO2",
          "Weight",
          "Body Fat",
          "Steps",
          "BMI",
        ]);
        setDisabledVitals([
          "Move Minutes",
          "Hydration",
          "Nutrition",
          "Cervical Mucus",
          "Cervical Position",
          "Menstruation",
          "Ovulation",
          "Sleep",
          "Vaginal spotting",
          "Blood Glucose",
          "Height",
          "Body Temperature",
          "ECG",
        ]);
        setMeasurmentId("Blood Pressure");
      } else if (integrationType === "iHealth") {
        setMeasurments([
          "Blood Pressure",
          "Heart Rate",
          "SPO2",
          "Weight",
          "Body Fat",
          "Steps",
          "BMI",
        ]);
        setDisabledVitals([
          "Move Minutes",
          "Hydration",
          "Nutrition",
          "Cervical Mucus",
          "Cervical Position",
          "Menstruation",
          "Ovulation",
          "Sleep",
          "Vaginal spotting",
          "Blood Glucose",
          "Height",
          "Body Temperature",
          "ECG",
        ]);
        setMeasurmentId("Blood Pressure");
      }
    }
  }, [selectedClient.integrationType]);

  const getClients = async () => {
    const res = await medplum.searchResources(
      "ClientApplication",
      `_count=100`
    );
    return res;
  };
  const showAiRecipes = async (showAi: number) => {
    setAiModal(false);
    setShowAiSummary(true);
    let summaryDetails = null;
    if (showAi == 1)
      summaryDetails = await formatAiSummary(
        medplum,
        patientId,
        setAiResponse,
        setCardioPrediction,
        setSummaryTags,
        setCardioRed
      );
    if (showAi == 2)
      summaryDetails = await formatCardioSummary(
        medplum,
        patientId,
        setAiResponse,
        setCardioPrediction,
        setSummaryTags,
        setCardioRed
      );
    if (showAi == 3)
      summaryDetails = await formatLosPrediction(
        medplum,
        patientId,
        setAiResponse,
        setCardioPrediction,
        setSummaryTags,
        setCardioRed
      );
    if (showAi == 4)
      summaryDetails = await formatReadmissionPrediction(
        medplum,
        patientId,
        setAiResponse,
        setCardioPrediction,
        setSummaryTags,
        setCardioRed
      );
    if (!summaryDetails) setShowAiSummary(false);
  };

  const disconnect = async () => {
    setDisconnecting(true);
    setClientsOptions([]);
    setSelectedClient({});
    await medplum.deleteResource("Device", selectedClient?.deviceId);
    setDisconnecting(false);
    getDevices();
  };

  const fetchCoverageResponse =async()=>{
    const response = await fetchCoverageResponseForPatient(patientId,medplum)
    console.log(response,'rr')
    setCoverageEligibilityResponse(response)

  }

  const getDevices = async () => {
    const res = await medplum.searchResources(
      "Device",
      `patient=Patient/${patientId}`
    );
    const tempNameArr: any = [];
    const tempIdArr: any = [];
    const selectedClientArr: any = [];
    res.forEach((device: any) => {
      tempNameArr.push(device?.deviceName[0].name);
      tempIdArr.push(device?.id);
    });
    const clients = await getClients();
    const newTempArr = [];
    for (let client of clients) {
      let tempClient: any = { ...client };
      let clientId = client.id;
      tempClient["integrationType"] = getIntegrationTypes(
        tempClient?.meta?.extension
      );
      if (tempNameArr.includes(clientId)) {
        let deviceIdx = tempNameArr.indexOf(clientId);
        tempClient["device"] = tempNameArr[deviceIdx];
        tempClient["deviceId"] = tempIdArr[deviceIdx];

        selectedClientArr.push(tempClient);
      }
      const clientTypes = getClientTypes(tempClient?.meta?.extension);
      if (clientTypes?.includes("Wearable")) {
        newTempArr.push(tempClient);
      }
    }
    setClientsOptions(newTempArr);
    if (selectedClientArr.length > 0) {
      const filteredArr = selectedClientArr.filter(
        (client: any) => client.id === clientId
      );
      if (clientId && filteredArr.length > 0) {
        setSelectedClient(filteredArr[0]);
      } else {
        setSelectedClient(selectedClientArr[0]);
      }
    }
  };

  const getPatientName = (patientData: any) => {
    let name = "--";
    if (patientData?.length > 0) {
      patientData.forEach((res: any) => {
        if (
          (res?.use === "official" || res?.use === "usual") &&
          name === "--"
        ) {
          name = res?.text || res?.given[0];
        }
      });
      if (name === "--")
        name = patientData[0]?.text || patientData[0]?.given || "--";
      if (typeof name !== "string") {
        name = String(name);
      }
    }
    return name;
  };

  const getPhoneNumber = (allTelecomRecords: any): string => {
    let phoneNumber = "--";
    if (allTelecomRecords?.length > 0) {
      for (const contact of allTelecomRecords) {
        if (contact?.telecom) {
          for (const telecomEntry of contact?.telecom) {
            phoneNumber = telecomEntry.value;
          }
        } else if (contact?.value) {
          phoneNumber = contact.value;
        }
      }
    }

    return phoneNumber;
  };
  const getPatientDetails = () => {
    medplum.readResource("Patient", `${patientId}`).then((res: any) => {
      setPatientDetails(res);
      if (
        res?.identifier?.find((id: any) => id.system ===
        "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id"
      ) ){
        setIsEpic(true);
        return;
      }
    });
  };

  interface AddressRecord {
    line: { value: string }[];
    city: String;
    state: String;
    postalCode: String;
    country: String;
  }
  const getAddress = (add: AddressRecord[]) => {
    let tempArr = [];
    if (add) {
      for (let address of add) {
        tempArr = [];
        if (address.line.length > 0) {
          tempArr.push(address.line[0]);
        }
        if (address.city) {
          tempArr.push(address.city);
        }
        if (address.state) {
          tempArr.push(address.state);
        }
        if (address.postalCode) {
          tempArr.push(address.postalCode);
        }
        if (address.country) {
          tempArr.push(address.country);
        }
      }
    }

    return tempArr.join(", ");
  };

  const onTabChange = (tabname: string) => {
    setActiveTab(tabname);
  };

  async function handleWearableButtonClick(
    e: React.MouseEvent<HTMLButtonElement>,
    resource: any,
    patientId: string
  ) {
    e.stopPropagation();
    const id = resource.id;
    localStorage.setItem("activeClient", JSON.stringify(resource));
    localStorage.setItem("selectedPatient", patientId);
    let vendor = "";
    const clientResource = resource;
    const secret = clientResource.secret;
    const integrationType = getIntegrationTypes(clientResource.meta.extension);
    if (integrationType.length > 0) {
      vendor = integrationType[0];
    }
    setVendor(vendor);
    setVisible(true);

    let apiPayload =
      vendor === "Garmin" || vendor === "iHealth"
        ? {
            eventType: "authUrl",
            clientId: id,
            patientId: patientId,
          }
        : {
            type: "url",
            client_id: id,
            secret: secret,
          };

    try {
      let botId = {};
      if (vendor === "Fitbit") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "fit-bit-service",
        };
      } else if (vendor === "Oura") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "oura-service",
        };
      } else if (vendor === "Google Fit") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "google-fit-service",
        };
      } else if (vendor === "Dexcom") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "dexcom-service",
        };
      } else if (vendor === "Polar") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "polar-service-new",
        };
      } else if (vendor === "Withings") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "withing-service",
        };
      } else if (vendor === "iHealth") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "iHealth-service",
        };
      } else if (vendor === "Garmin") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "garmin-service",
        };
      } else {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "strava-service",
        };
      }
      const result = await medplum.executeBot(botId, apiPayload);
      if (result.statusCode === 301) {
        let redirectUrl;
        if (vendor === "iHealth") {
          redirectUrl = result.body.authUrl;
        } else {
          redirectUrl = result.body;
        }
        window.location.href = redirectUrl;
      } else if (vendor === "Garmin") {
        localStorage.setItem(
          "GARMIN_AUTH",
          JSON.stringify(result?.body?.oauth)
        );
        window.location.href = result.body.auth_url;
      } else {
        setVisible(false);
      }
    } catch (error: any) {
      console.error("Error during external authentication:", error);
      setVisible(false);
    }
  }
  const handleCallback = (data: boolean) => {
    setRefreshFlag((prev) => !prev);
  };

  return (
    <>
      {disconnecting && (
        <Box
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Loader />
        </Box>
      )}
      {visible && (
        <RedirectingModal
          isOpen={visible}
          onClose={() => setVisible(false)}
          vendor={vendor}
          text={"Redirecting..."}
        />
      )}
      <AIRecipesModal
        opened={aiModal}
        onClose={() => setAiModal(false)}
        submit={showAiRecipes}
      />
      <PatientTabs
        currentTab={"Details"}
        patientName={getPatientName(patientDetails?.name)}
        patient={patientDetails}
        showSummaryClick={() => setAiModal(true)}
        showSummaryDisable={aiResponse === "Generating..."}
      />
      <Paper
        sx={{
          marginTop: "20px",
          borderRadius: "8px",
          marginLeft: "40px",
          marginRight: "40px",
          padding: "20px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
      >
        <Box
          mb={16}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              justifyContent: "center",
              alignItems: "center",
              height: "94px",
            }}
          >
            <Box>{/* <Avatar src={doctorSvg} /> */}</Box>
            <Box fw={600} sx={{ fontSize: "24px" }} lh={"34px"}>
              {" "}
              {getPatientName(patientDetails?.name)}
            </Box>
          </Box>
          <Box
            sx={{
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              display: "flex",
              flexDirection: "row",
              padding: "16px",
              gap: "24px",
              minWidth: "424px",
              justifyContent: "space-around",
            }}
          >
            <Box>
              <Text fw={500} fs={"16px"} lh={"22px"} color="#818999" mb={16}>
               Payer Name
              </Text>
              <Text fw={500} fs={"16px"} lh={"22px"} color="#262930">
                {coverageEligibilityResponse?.organizationName??"--"}
              </Text>
              <Divider orientation="vertical" />
            </Box>
            <Box>
              <Text fw={500} fs={"16px"} lh={"22px"} color="#818999" mb={16}>
                Status
              </Text>
              <Badge c={'orange'}>
              <Text fw={500} fs={"16px"} lh={"22px"} color="#262930">
              {coverageEligibilityResponse?.outcome??"--"}
              </Text>
              </Badge>
              <Divider orientation="vertical" />
            </Box>
            <Box>
              <Text fw={500} fs={"16px"} lh={"22px"} color="#818999" mb={16}>
Service Period              </Text>
              <Text fw={500} fs={"16px"} lh={"22px"} color="#262930">
                {coverageEligibilityResponse?.servicedPeriod?.start??"--"}{" "}to{" "} {coverageEligibilityResponse?.servicedPeriod?.end??"--"}

              </Text>
              <Divider orientation="vertical" />
            </Box>
          </Box>
        </Box>
        <div className="nameAndPicWrap">
          {/* <Avatar  radius="xl" /> */}
          {/* <Title>{getPatientName(patientDetails?.name)}</Title> */}
        </div>
        <div className="patientDetailsWrap">
          <div>
            <div className="detailsHead">Date of birth</div>
            <div className="detailsVal">{patientDetails?.birthDate}</div>
          </div>
          <div>
            <div className="detailsHead">Gender</div>
            <div className="detailsVal">{patientDetails?.gender}</div>
          </div>
          <div>
            <div className="detailsHead">Mobile</div>
            <div className="detailsVal">
              {getPhoneNumber(
                patientDetails?.contact || patientDetails?.telecom
              )}
            </div>
          </div>
          <div>
            <div className="detailsHead">Address</div>
            <div className="detailsVal">
              {getAddress(patientDetails?.address)}
            </div>
          </div>
          {/* <div>
              <div className="detailsHead">Practitioner</div>
              <div className="detailsVal">
                {patientDetails?.generalPractitioner?.[0]?.display ?? "--"}
              </div>
            </div> */}
        </div>
      </Paper>
      {showAiSummary && (
        <Paper
          sx={{
            marginTop: "20px",
            borderRadius: "8px",
            marginLeft: "40px",
            marginRight: "40px",
            padding: "20px",
            background: "'#FFF",
            display: "flex",
            flexDirection: "column",
            boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
            minHeight: "500px",
          }}
        >
          <Summary
            text={aiResponse}
            cardiovascular={cardioPrediction}
            diseases={summaryTags?.diseases}
            drugs={summaryTags?.drugs}
            observations={summaryTags?.observations}
            cardioRed={cardioRed}
          />
        </Paper>
      )}

      <Paper
        sx={{
          marginTop: "20px",
          borderRadius: "8px",
          marginLeft: "40px",
          marginRight: "40px",
          padding: "20px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
          minHeight: "400px",
        }}
      >
        <Flex justify="space-between" align={"center"}>
          <Title sx={{ fontSize: "22px", fontWeight: "bold" }}>
            Vital Signs
          </Title>
          <Flex gap={15}>
            <Button onClick={()=>{setPushToEpic(true)}} disabled={measurementId!=='Blood Pressure'}> Push to EPIC </Button>
            {selectedClient.deviceId && (
              <Button variant="outline" color="lime" onClick={disconnect}>
                {selectedClient?.integrationType && (
                  <Box
                    component="img"
                    src={
                      circularPlatformLogo[
                        selectedClient?.integrationType[0]
                          ?.replace(/\s/g, "")
                          ?.toLowerCase()
                      ]
                    }
                    className={classes.platformLogo}
                  />
                )}
                Disconnect
              </Button>
            )}
            <Menu shadow="md">
              <Menu.Target>
                <Button variant="outline" rightIcon={<IconCaretDown />}>
                  {selectedClient?.integrationType && (
                    <Box
                      component="img"
                      src={
                        circularPlatformLogo[
                          selectedClient?.integrationType[0]
                            ?.replace(/\s/g, "")
                            ?.toLowerCase()
                        ]
                      }
                      className={classes.platformLogo}
                    />
                  )}

                  {selectedClient?.name
                    ? `${selectedClient?.name} Connected`
                    : "0 Clients Connected"}
                </Button>
              </Menu.Target>

              <Menu.Dropdown pl={0} pr={0}>
                {clientsOptions.map((client: any) => {
                  return (
                    <Fragment key={client.id}>
                      <Menu.Item
                        onClick={(e) => {
                          client.device
                            ? setSelectedClient(client)
                            : handleWearableButtonClick(e, client, patientId);
                        }}
                        icon={client.device && <span className="connectDot" />}
                        sx={{
                          backgroundColor: client.device
                            ? "#E7FFE5"
                            : "transparent",
                        }}
                      >
                        {client?.name}
                      </Menu.Item>
                      <Menu.Divider mt={0} mb={0} />
                    </Fragment>
                  );
                })}
              </Menu.Dropdown>
            </Menu>
          </Flex>
        </Flex>
        <Divider my="md" />
        <ScrollArea h={"50px"}>
          <Flex align={"center"} gap={10}>
            {measurements.map((val) => {
              return (
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    setMeasurmentId(val);
                    console.log(val,'val')
                  }}
                  variant={measurementId === val ? "filled" : "outline"}
                  type="button"
                  key={val}
                >
                  {val}
                </Button>
              );
            })}
            {disabledVitals.map((val) => {
              return (
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    setMeasurmentId(val);
                  }}
                  variant={measurementId === val ? "filled" : "outline"}
                  type="button"
                  key={val}
                  disabled={true}
                >
                  {val}
                </Button>
              );
            })}
          </Flex>
        </ScrollArea>
        {measurementId && (
          <Measurement
            patientId={patientId}
            measurementId={measurementId}
            deviceId={selectedClient.deviceId}
            pushToEpic={pushToEpic}
            setPushToEpic={setPushToEpic}
          />
        )}
      </Paper>
      <Paper
        sx={{
          marginTop: "20px",
          borderRadius: "8px",
          marginLeft: "40px",
          marginRight: "40px",
          padding: "20px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
          minHeight: "400px",
        }}
      >
        <Flex justify={"space-between"}>
          <Title sx={{ fontSize: "22px", fontWeight: "bold" }}>Details</Title>
        </Flex>
        <Tabs value={activeTab} onTabChange={onTabChange}>
          <Tabs.List
            style={{
              whiteSpace: "nowrap",
              flexWrap: "nowrap",
              width: "fit-content",
              marginBottom: "30px",
            }}
          >
            {tabs.map((t) => (
              <Tabs.Tab
                key={t}
                value={t}
                sx={{
                  color: activeTab === t ? "#1B75BC" : "#99A0AD",
                  fontFamily: "Montserrat",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "22px",
                }}
              >
                {t}
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs>
        {activeTab === "Medical History" && (
          <MedicalHistory pName={getPatientName(patientDetails?.name)} />
        )}
        {activeTab === "Observations" && <Observation />}
        {activeTab === "Immunization" && <Immunization />}
        {activeTab === "Diagnostic Reports" && (
          <Reports pName={getPatientName(patientDetails?.name)} />
        )}
        {activeTab === "Care Team" && <CareTeam />}
        {activeTab === "Care Plan" && <CarePlan PatientDetails={patientDetails}/>}

        {activeTab === "Appointments" &&
          (isEpic ? (
            <AppointmentPage patientID={patientId} showPatientDetails={true} />
          ) : (
            <>
              {" "}
              {/* <Paper className={classes.medicalDocPaper} withBorder>
                  <Flex justify={"space-between"}>
                    <Title>Appointments</Title>
                    <Button
                      onClick={() => {
                        navigate(
                          `admin/appointments/newappointment/${patientId}`
                        );
                      }}
                    >
                      New Appointment
                    </Button>
                  </Flex>
                </Paper> */}
              <Appointment />
            </>
          ))}

        {activeTab === "Clinical Documents" && (
          <DocReports
            setIsMedicalDocumentModalOpen={setIsMedicalDocumentModalOpen}
            patient={patientDetails}
            refreshFlag={refreshFlag}
          />
        )}
      </Paper>
      {isMedicalDocumentModalOpen && (
        <MedicalDocumentModal
          isMedicalDocumentModalOpen={isMedicalDocumentModalOpen}
          setIsMedicalDocumentModalOpen={setIsMedicalDocumentModalOpen}
          patientDetails={patientDetails}
          getPatientName={getPatientName}
          callbackValue={handleCallback}
        />
      )}
      {/* <ActionIcon style={{ position: "fixed", bottom: "20px", right: "20px" }></ActionIcon> */}
      <ChatWindow
        patientId={patientId}
        // practiotnerId={"4c76674d-7fe8-4b59-8bc0-2e02b9a8f02c"}
        practiotnerId={profile?.id as string}
        name={getPatientName(patientDetails?.name)}
        selectedClients={selectedClient}
      />
      {/* <ActionIcon size={42} variant="default" aria-label="ActionIcon with size as a number">
      <IconHeart style={{ width: rem(24), height: rem(24) }} />
    </ActionIcon> */}
    </>
  );
}
